__turbopack_context__.v({
  "contentPageHeading": "ContentPageHeading-module-scss-module__hkIlNG__contentPageHeading",
});
